module.exports = __webpack_public_path__ + "static/media/benifits bg.20a863b9.png";